import React from 'react'

const UserCheck = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M299.29 287.5h-86.58c-85.14 0-154.42 69.27-154.42 154.42V544h395.42V441.92c0-85.15-69.28-154.42-154.42-154.42zM88.29 514v-72.08c0-68.61 55.82-124.42 124.42-124.42h86.58c68.6 0 124.42 55.81 124.42 124.42V514H88.29zM249 37c-65.84 0-119.41 53.57-119.41 119.41S183.16 275.82 249 275.82s119.41-53.57 119.41-119.41S314.84 37 249 37zm0 208.82c-49.3 0-89.41-40.11-89.41-89.41S199.7 67 249 67s89.41 40.11 89.41 89.41-40.11 89.41-89.41 89.41z"
      />
      <path
        fill={color}
        stroke="null"
        d="M455.8 210.132l-53.842 54.617-28.758-29.17-17.735 17.99 46.493 47.17 71.577-72.616-17.735-17.991zm0 0"
      />
    </svg>
  )
}

UserCheck.defaultProps = {
  size: 30,
  color: '#555555',
}

export default UserCheck
